const defaultValues = {
  farmsNumberLimit: 50,
  barnsNumberLimit: 20
}

export default defaultValues;